import * as React from 'react';
import * as styles from './styles.css';
import successIcon from './assets/Success.svg';

import { ArticleParagraph1 } from '@cian/ui-kit';

export const SaveDataAnnotation: React.FC = () => {
  return (
    <div className={styles['annotation']}>
      <div className={styles['title']}>
        <div className={styles['icon']}>
          <img src={successIcon} />
        </div>

        <div className={styles['text']}>
          <ArticleParagraph1>Данные в безопасности — никому их не передаём и не спамим</ArticleParagraph1>
        </div>
      </div>
    </div>
  );
};
